export const translationJobErrorMessageMap: Record<string, string> = {
    TRANSLATION_JOB_INSUFFICIENT_BALANCE: "w_TranslationJobConfirmInsufficient",
    TRANSLATION_JOB_WALLET_NOT_FOUND: "w_TranslationJobConfirmWalletNotFound",
};

export const translationJobFallbackKey = "w_TranslationJobConfirmFailed";

export const translationJobAnalyzeErrorMessageMap: Record<string, string> = {
    TRANSLATION_JOB_ANALYZE_BAD_ZIP: "w_TranslationJobAnalyzeBadZip",
};

export const translationJobAnalyzeFallbackKey = "w_TranslationJobAnalyzeFailed";
